export const SPACELIFT_LANDING_URL = window.location.hostname.split(".").slice(-2).join(".");
export const SCHEDULE_DEMO_LINK = "https://spacelift.io/schedule-demo";
